/* ==========================================================================
   Criar Sin Miedo — comportamiento propio
   Todo vanilla, sin librerías. Cada init comprueba que su elemento existe.
   ========================================================================== */

(function () {
  'use strict';

  // Este archivo va incluido en TODAS las secciones csm-. Cuando una página
  // monta varias a la vez (la ficha de producto monta seis), el navegador
  // ejecuta el script una vez por etiqueta. Sin este cerrojo los listeners se
  // registran repetidos y UN SOLO clic en comprar añade el producto varias
  // veces al carrito: la clienta llegaba al pago con 49,98 € en vez de 24,99 €.
  if (window.csmScriptsCargado) return;
  window.csmScriptsCargado = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada --------------------------------------------- */

  function initReveal() {
    var elementos = document.querySelectorAll('.csm-reveal');
    if (!elementos.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) {
        el.classList.add('csm-visible');
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('csm-visible');
            observador.unobserve(entrada.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    elementos.forEach(function (el) {
      observador.observe(el);
    });
  }

  /* --- Galería de producto -------------------------------------------------- */

  function initGaleria() {
    var galerias = document.querySelectorAll('[data-csm-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      if (galeria.getAttribute('data-csm-iniciada') === 'si') return;
      galeria.setAttribute('data-csm-iniciada', 'si');

      var principal = galeria.querySelector('[data-csm-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-csm-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var url = mini.getAttribute('data-csm-mini');
          var alt = mini.getAttribute('data-csm-alt') || '';
          if (!url) return;
          principal.src = url;
          principal.alt = alt;
          minis.forEach(function (m) {
            m.classList.remove('is-activa');
          });
          mini.classList.add('is-activa');
        });
      });
    });
  }

  /* --- Order bumps + añadir al carrito -------------------------------------- */

  function formateaDinero(centimos, simbolo) {
    var valor = (centimos / 100).toFixed(2).replace('.', ',');
    // Separador de miles con punto (formato español)
    var partes = valor.split(',');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    valor = partes.join(',');
    return simbolo ? valor + ' ' + simbolo : valor;
  }

  function initCompra() {
    var bloques = document.querySelectorAll('[data-csm-compra]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      // El editor de Shopify vuelve a lanzar arranca() al recargar una sección.
      if (bloque.getAttribute('data-csm-iniciado') === 'si') return;
      bloque.setAttribute('data-csm-iniciado', 'si');

      var form = bloque.querySelector('[data-csm-form]');
      var bumps = bloque.querySelectorAll('[data-csm-bump]');
      var totalEl = bloque.querySelector('[data-csm-total]');
      var boton = bloque.querySelector('[data-csm-boton]');
      var textoBoton = boton ? boton.querySelector('[data-csm-boton-texto]') : null;
      if (!form) return;

      var precioBase = parseInt(bloque.getAttribute('data-csm-precio-base') || '0', 10);
      var simboloDinero = bloque.getAttribute('data-csm-simbolo') || '€';
      var trasAnadir = bloque.getAttribute('data-csm-tras-anadir') || 'checkout';

      var regalo = bloque.querySelector('[data-csm-regalo]');

      function hayComplemento() {
        var alguno = false;
        bumps.forEach(function (bump) {
          var input = bump.querySelector('input[type="checkbox"]');
          if (input && input.checked) alguno = true;
        });
        return alguno;
      }

      function recalcula() {
        var total = precioBase;
        bumps.forEach(function (bump) {
          var input = bump.querySelector('input[type="checkbox"]');
          if (input && input.checked) {
            total += parseInt(bump.getAttribute('data-csm-precio') || '0', 10);
          }
        });
        var formateado = formateaDinero(total, simboloDinero);
        if (totalEl) totalEl.textContent = formateado;
        // La barra fija del móvil enseña el total en vivo, con los complementos incluidos
        var barraTotal = document.querySelector('[data-csm-barra-total]');
        if (barraTotal) barraTotal.textContent = formateado;
        if (regalo) regalo.classList.toggle('is-desbloqueado', hayComplemento());
      }

      bumps.forEach(function (bump) {
        var input = bump.querySelector('input[type="checkbox"]');
        if (!input) return;
        function sincroniza() {
          bump.classList.toggle('is-marcado', input.checked);
          recalcula();
        }
        input.addEventListener('change', sincroniza);
        sincroniza();
      });

      recalcula();

      // Si no hay bumps ni carrito AJAX disponible, dejamos el envío normal.
      if (!bumps.length) return;

      form.addEventListener('submit', function (evento) {
        evento.preventDefault();

        var idPrincipal = form.querySelector('input[name="id"]');
        if (!idPrincipal || !idPrincipal.value) {
          form.submit();
          return;
        }

        var articulos = [{ id: parseInt(idPrincipal.value, 10), quantity: 1 }];
        bumps.forEach(function (bump) {
          var input = bump.querySelector('input[type="checkbox"]');
          var variante = bump.getAttribute('data-csm-variante');
          if (input && input.checked && variante) {
            articulos.push({ id: parseInt(variante, 10), quantity: 1 });
          }
        });

        // Si ha añadido algún complemento, el regalo entra solo.
        if (regalo && hayComplemento()) {
          var varianteRegalo = regalo.getAttribute('data-csm-variante');
          if (varianteRegalo) {
            articulos.push({ id: parseInt(varianteRegalo, 10), quantity: 1 });
          }
        }

        if (boton) {
          boton.setAttribute('aria-busy', 'true');
          boton.disabled = true;
          if (textoBoton) {
            textoBoton.setAttribute('data-csm-original', textoBoton.textContent);
            textoBoton.textContent = 'Añadiendo…';
          }
        }

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: articulos })
        })
          .then(function (respuesta) {
            if (!respuesta.ok) throw new Error('cart');
            return respuesta.json();
          })
          .then(function () {
            if (trasAnadir === 'carrito') {
              window.location.href = '/cart';
            } else {
              window.location.href = '/checkout';
            }
          })
          .catch(function () {
            // Si algo falla, hacemos el envío clásico del formulario.
            if (boton) {
              boton.disabled = false;
              boton.removeAttribute('aria-busy');
              if (textoBoton && textoBoton.getAttribute('data-csm-original')) {
                textoBoton.textContent = textoBoton.getAttribute('data-csm-original');
              }
            }
            form.submit();
          });
      });
    });
  }

  /* --- Marquesina: duplica el contenido para que el bucle sea continuo ------- */

  function initMarquee() {
    var pistas = document.querySelectorAll('[data-csm-marquee]');
    if (!pistas.length) return;
    pistas.forEach(function (pista) {
      if (pista.getAttribute('data-csm-duplicada') === 'si') return;
      pista.innerHTML = pista.innerHTML + pista.innerHTML;
      pista.setAttribute('data-csm-duplicada', 'si');
    });
  }

  /* --- Barra de compra fija en móvil ----------------------------------------- */

  function initBarra() {
    var barra = document.querySelector('[data-csm-barra]');
    if (!barra) return;
    if (barra.getAttribute('data-csm-iniciada') === 'si') return;
    barra.setAttribute('data-csm-iniciada', 'si');

    var desde = parseInt(barra.getAttribute('data-csm-desde') || '600', 10);

    // En la ficha de producto, el botón de la barra compra directamente
    // (con los complementos que estén marcados) en vez de recargar la página.
    var botonReal = document.querySelector('[data-csm-compra] [data-csm-boton]');
    var enlaceBarra = barra.querySelector('a');
    if (botonReal && enlaceBarra) {
      enlaceBarra.addEventListener('click', function (evento) {
        evento.preventDefault();
        botonReal.click();
      });
    }

    function revisa() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      barra.classList.toggle('is-visible', y > desde);
    }

    window.addEventListener('scroll', revisa, { passive: true });
    window.addEventListener('resize', revisa, { passive: true });

    revisa();
  }

  /* --- Arranque -------------------------------------------------------------- */

  function arranca() {
    initReveal();
    initGaleria();
    initCompra();
    initMarquee();
    initBarra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }

  // El editor de Shopify recarga secciones sueltas: volvemos a inicializar.
  document.addEventListener('shopify:section:load', arranca);
})();
